"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMSBStates = void 0;
const react_1 = __importStar(require("react"));
const useDidUpdate_1 = require("../../../providers/useDidUpdate");
const HiddenState = ({ children, id }) => (react_1.default.createElement("span", { style: { display: 'none' }, id: id }, children));
const useMSBStates = ({ children, getStateId, selectedStateId, onChange, }) => {
    /**
     * We keep state memory to preserve DOM state (like inputs)
     */
    const [pastStateIds, setPastStateIds] = (0, react_1.useState)([]);
    (0, useDidUpdate_1.useDidUpdate)(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ type: 'change' });
        if (!pastStateIds.includes(selectedStateId)) {
            setPastStateIds([...pastStateIds, selectedStateId]);
        }
    }, [selectedStateId]);
    /**
     * TB Containers pass children as a function
     */
    const stateElements = react_1.default.Children.toArray(typeof children === 'function' ? children() : children);
    const currentOrPastStates = stateElements.filter(state => {
        if (!react_1.default.isValidElement(state)) {
            return false;
        }
        const itemId = getStateId(state);
        return selectedStateId === itemId || pastStateIds.includes(itemId);
    });
    if (currentOrPastStates.length) {
        return currentOrPastStates.map(state => selectedStateId === getStateId(state) ? (state) : (
        // If we rendered this state in the past - render it hidden, to maintain DOM state
        react_1.default.createElement(HiddenState, { id: state.props.id }, state)));
    }
    return stateElements.slice(0, 1);
};
exports.useMSBStates = useMSBStates;
//# sourceMappingURL=useMSBStates.js.map